import { render, staticRenderFns } from "./WalletList.vue?vue&type=template&id=4c54f98d&"
import script from "./WalletList.vue?vue&type=script&lang=ts&"
export * from "./WalletList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports